module.exports = __webpack_public_path__ + "static/media/Team 40 - HexaEfficient.ef62edea.png";